import React, { useState,useEffect } from "react";

//icons
import arrowSimple from "../../assets/icons/arrowSimple.svg";
import arrowSimpleUp from "../../assets/icons/arrowSimpleUp.svg";

//Material ui
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import arrow from '../../assets/icons/arrow2.svg';
import Loader from "react-loader-spinner";
//axios
import axios from 'axios'
//constantes
import * as Constant from '../../global/const'
import auth from '../../Helpers/auth'


const StyledTableCell = withStyles((theme) => ({
  head: {
    color: "black",
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {},
  },
}))(TableRow);


var Slider = {
  position: 'absolute',
  backgroundColor: '#fff',
  border:"2px solid #0075bb",
  borderTop:0,
  width: '100%',
  top: '100%',
  //right:'2.5%',
  //top:'21.6rem',
  zIndex:'4',
  paddingRight: '.2rem',
  height: '30vh',
  overflow: 'hidden',
  opacity:'1',
  cursor: 'auto',
  borderRadius:' 0 0 20px 20px',
  transition: 'all 0.2s',
  } 

  var SliderMovil = {
      position: 'fixed',
      backgroundColor: '#fff',
      border:"2px solid #0075bb",
      width: '80vw',
      zIndex:'4',
      paddingRight: '.2rem',
      height: '50vh',
      top:'10rem',
      overflow: 'hidden',
      opacity:'1',
      cursor: 'auto',
      borderRadius:'20px',
      transition: 'all 0.5s',
      } 

    var  CloseSliderMovil={
      position: 'fixed',
      backgroundColor: '#fff',           
      width: '80vw',
      zIndex:'4',
      paddingRight: 0,
      height: 0,
      top:'10rem',
      overflow: 'hidden',
      opacity:'1',
      cursor: 'auto',
      borderRadius:'20px',
      transition: 'all 0.5s',

      }

  var CloseSlider = {
      height: 0,
      border:'0px',        
      zIndex:'4',
     position: 'absolute',
     backgroundColor: '#fff',
     width: '100%',
     //right:'2.5%',
     //top:'21.6rem',
     top: '100%',
     overflow: 'hidden',
     opacity:'1',
     transition: 'all 0.2s',
      } 




const MisPrestamos = () => {
  const [contentPrestamo, setcontentPrestamo] = useState(true);

  return (
    <div className="ContentPrestamos">
      <div className="prestamosHeader">
        <div className="select-left" onClick={() => setcontentPrestamo(true)}>
          <h1
            style={
              contentPrestamo ? { borderBottom: "10px solid #0075BB" } : null
            }
          >
            Elementos en Prestamo
          </h1>
          <h1
            style={
              contentPrestamo ? { borderBottom: "10px solid #0075BB" } : null
            }
          >
            6
          </h1>
        </div>
        <div className="select-rigth" onClick={() => setcontentPrestamo(false)}>
          <h1
            style={
              !contentPrestamo ? { borderBottom: "10px solid #0075BB" } : null
            }
          >
            Solicitudes Pendientes
          </h1>
          <h1
            style={
              !contentPrestamo ? { borderBottom: "10px solid #0075BB" } : null
            }
          >
            6
          </h1>
        </div>
      </div>
      <div className="bodyContent">
        {contentPrestamo ? <Prestamo /> : <Pendientes />}
      </div>
    </div>
  );
};

const Prestamo = () => {
  const [sucursal,setsucursal]=useState(null)
  const [OpenModal, setOpenModal] = useState(false);
  const [sucursales,setsucursales]=useState([])
  const [Allsucursales, setAllsucursales] = useState([])
  const [Error, setError] = useState(null)
  const [prestamos,setprestamos]=useState([])
  const [close, setclose] = useState(false) 

  useEffect(() => {
    getSucursales();
  }, [])

  const getPrestamos=(sucursal)=>{
    setprestamos([])
    setError(null)    
    axios.get(Constant.GETPRESTAMOS + `?nit=${sucursal.nit}&codigo=${sucursal.codigo}&agencia=${sucursal.agencia}`).then((response) => {
      if(response.data.productos.length===0){
        setError('Esta sucursal no tienen productos en prestamo')
        return
      }
      setprestamos(response.data.productos)                          
  }).catch((err) => {
    if(err.response.data.error){
      setError(err.response.data.error)
  }
  })
  }

  const getSucursales = () => {
    let user = JSON.parse(auth.getUsuario())
    axios.get(Constant.GETSUCRUSALES  + "?correo=" + user.email).then((response) => {
        setAllsucursales(response.data);
        setsucursales(response.data)
        setsucursal(response.data[0])
        getPrestamos(response.data[0])                    
    }).catch((err) => {
        console.log("sucursales ",err);
    })
}

const Filtrar=(sucursal)=>{
  setsucursal(sucursal);
  getPrestamos(sucursal);
  setclose(false)        
  /*   if(ciudad!=='TODAS'){
      setfilter(ciudad)
      const arraySearch=Array.from(Allsucursales)
      const results=arraySearch.filter((e)=>e.ciudad===ciudad);          
      setsucursales(results)
    }else{
        setfilter(ciudad)
        setsucursales(Allsucursales)
    }
    setclose(false) */
}

const Search=(term)=>{
  if(term.trim()!==''){
  const arraySearch=Array.from(Allsucursales)
  const SearchRepositories = arraySearch.filter(item => {
       return (
           item.nombre.toLowerCase().trim().indexOf(term.toLowerCase().trim()) >= 0
            || item.codigo.toLowerCase().trim().indexOf(term.toLowerCase().trim()) >= 0 
           || item.razonsocial.toLowerCase().trim().indexOf(term.toLowerCase().trim()) >= 0
       )
     })
      
  var results=SearchRepositories;           
  setsucursales(results)
  }else{        
       setsucursales(Allsucursales)
  }
 }


  return (
    <div className="contentOne">
      <div className="headerOne">        
        <div className="topHeader">
        <h1>Estos son tus elementos en Prestamo</h1>
        <div className="sucursalesPuntos">                    
                <div className="btn-sucursales no-seleccionable" onClick={()=>setclose(!close)}>
                <h4>{sucursal?sucursal.razonsocial==='TODAS'? 'Todas las sucursales' :`Sucursales de ${
                  sucursal ? 
                    sucursal.razonsocial.length > 12
                    ?
                    sucursal.razonsocial.substring(0, 12) + "..."
                    :
                    sucursal.razonsocial
                     : null
                }`:null}</h4>
                <img src={arrow} alt="" />
                </div>
            <div className="close desk slider-sucursales overflow-auto scrollSlider" /* ref={myRef} */ style={ !close ? CloseSlider: Slider}>
              <div className="BuscarSucursal">
                <input type="text" onChange={(e)=>Search(e.target.value)} placeholder="Sucursal"/>
              </div>
            <div className="opciones">
                {sucursales.map((sucursal,i)=>(
                     <div key={i} className="opcion"  onClick={()=> Filtrar(sucursal)} >
                         <h6 className="no-seleccionable">{sucursal.razonsocial}</h6>
                     </div>
                ))}                                       
            </div>
          </div>
          <div className="close movil slider-sucursales overflow-auto scrollSlider" /* ref={myRef} */ style={ !close ? CloseSliderMovil: SliderMovil}>
                <div className="opciones ">
                {sucursales.map((sucursal,i)=>(
                     <div key={i} className="opcion" /* onClick={()=> Filtrar(ciudad)} */>
                         <h6 className="no-seleccionable">{sucursal.razonsocial}</h6>
                     </div>
                ))}                                        
                </div>
            </div>
            </div>
        </div>
        <p>
          Este es un resumen de los elementos que te hemos prestado, aquí puedes
          solicitar la devolución de estos
        </p>
      </div>
      <div className="bodyOne">
        <div className="headerBodyOne">
          <h1>
            <span>2 elementos </span>para solicitar devolución recuerda que se
            reciben cuando se realice el pedido
          </h1>
          <div className="btnPrestamo no-seleccionable">
            <span>Devolver Elementos</span>
          </div>
        </div>
        <TablePrestamo prestamos={prestamos} Error={Error} />
      </div>
      {OpenModal ? (
        <div className="modalContainer">
          {" "}
          <ModalPrestamo setOpenModal={setOpenModal} prestamos={prestamos} />
        </div>
      ) : null}
      <div className="footerOne">
        <div
          className="btnPrestamo no-seleccionable"
          onClick={() => {
            setOpenModal(true);
            window.scrollTo(0, 0);
          }}
        >
          <span>Ver Tabla en Ventana Aparte</span>
        </div>
      </div>
    </div>
  );
};

const ModalPrestamo = ({ setOpenModal,prestamos }) => {
  return (
    <div className="modalPrestamo">
      <div className="HeaderModalPrestamo">
        <h1>Estos son tus elementos en Prestamo</h1>
        <div onClick={() => setOpenModal(false)}>
          <h1>Cerrar</h1>
          <i className="fas fa-times"> </i>
        </div>
      </div>
      <div className="BodyModalPrestamo">
        <TablePrestamo prestamos={prestamos}/>
      </div>
      <div className="FooterModalPrestamo">
        <h1><span>2 elementos </span>para solicitar devolución recuerda que se reciben cuando se realice el pedido</h1>
        <div className="btnModal">
          <span>Devolver Elementos</span>
        </div>
      </div>
    </div>
  );
};

const TablePrestamo = ({prestamos,Error}) => {
  const [Term, setTerm] = useState("");
  const [prestamosAll,setprestamosAll]=useState(prestamos);
  const [Prestamos, setPrestamos] = useState(prestamos)

  useEffect(() => {
    setPrestamos(prestamos)
    setprestamosAll(prestamos)
  }, [prestamos])
  

  const Order = (term) => {
    if (term === Term) {
      setTerm("");
      setPrestamos(prestamosAll);
      return;
    }
    const Aux = [...prestamosAll];    
    var order;
    setTerm(term);
    switch (term) {
      case "nombre":
        order = Aux.sort(function (a, b) {
          if (a.producto > b.producto) {
            return 1;
          }
          if (a.producto < b.producto) {
            return -1;
          }
          return 0;
        });
        break;
      case "codigo":
        order = Aux.sort(function (a, b) {
          if (a.codproducto > b.codproducto) {
            return 1;
          }
          if (a.codproducto < b.codproducto) {
            return -1;
          }
          return 0;
        });
        break;
        case "tipo":
        order = Aux.sort(function (a, b) {
          if (a.tipoprestamo > b.tipoprestamo) {
            return 1;
          }
          if (a.tipoprestamo < b.tipoprestamo) {
            return -1;
          }
          return 0;
        });
        break;
      case "CantCajas":
        order = Aux.sort(function (a, b) {
          if (a.caja > b.caja) {
            return 1;
          }
          if (a.caja < b.caja) {
            return -1;
          }
          return 0;
        });
        break;
      case "CantUnidades":
        order = Aux.sort(function (a, b) {
          if (a.unidad > b.unidad) {
            return 1;
          }
          if (a.unidad < b.unidad) {
            return -1;
          }
          return 0;
        });
        break;
        case "valor":
        order = Aux.sort(function (a, b) {
          if (a.valor > b.valor) {
            return 1;
          }
          if (a.valor < b.valor) {
            return -1;
          }
          return 0;
        });
        break;
      default:
        break;
    }
    
    setPrestamos(order);
  };
  return (
    <div className="tablaOne">
      <TableContainer component={Paper}>
        <Table
          className="overflow-auto scrollSlider"
          /* stickyHeader */
          aria-label="sticky table"
        >
          <TableHead className="tableHead">
            <TableRow>
              <StyledTableCell>Solicitar para devolucion </StyledTableCell>              
              <StyledTableCell
                className="no-seleccionable"
                onClick={() => Order("nombre")}
              >
                <span>Nombre del Elemento</span>{" "}
                {Term === "nombre" ? (
                  <img src={arrowSimpleUp} alt="" />
                ) : (
                  <img src={arrowSimple} alt="" />
                )}
              </StyledTableCell>
              <StyledTableCell
                className="no-seleccionable"
                onClick={() => Order("codigo")}
              >
                <span>Código</span>{" "}
                {Term === "codigo" ? (
                  <img src={arrowSimpleUp} alt="" />
                ) : (
                  <img src={arrowSimple} alt="" />
                )}
              </StyledTableCell>               
              <StyledTableCell
                className="no-seleccionable"
                onClick={() => Order("CantCajas")}
              >
                <span>Cantidad de cajas</span>{" "}
                {Term === "CantCajas" ? (
                  <img src={arrowSimpleUp} alt="" />
                ) : (
                  <img src={arrowSimple} alt="" />
                )}
              </StyledTableCell>
              <StyledTableCell
                className="no-seleccionable"
                onClick={() => Order("CantUnidades")}
              >
                <span>Cantidad de unidades</span>{" "}
                {Term === "CantUnidades" ? (
                  <img src={arrowSimpleUp} alt="" />
                ) : (
                  <img src={arrowSimple} alt="" />
                )}
              </StyledTableCell>
              <StyledTableCell
                className="no-seleccionable"
                onClick={() => Order("tipo")}
              >
                <span>Tipo de prestamo</span>
                {Term === "tipo" ? (
                  <img src={arrowSimpleUp} alt="" />
                ) : (
                  <img src={arrowSimple} alt="" />
                )}
              </StyledTableCell>
              <StyledTableCell
                className="no-seleccionable"
                onClick={() => Order("valor")}
              >
                <span>Valor</span>
                {Term === "valor" ? (
                  <img src={arrowSimpleUp} alt="" />
                ) : (
                  <img src={arrowSimple} alt="" />
                )}
              </StyledTableCell>
               {/* <StyledTableCell
                className="no-seleccionable"
                onClick={() => Order("numDoc")}
              >
                <span>Compañia</span>
                {Term === "numDoc" ? (
                  <img src={arrowSimpleUp} alt="" />
                ) : (
                  <img src={arrowSimple} alt="" />
                )}
              </StyledTableCell>  */}
            </TableRow>
          </TableHead>
          <TableBody className="tableBody">
           {!Error?
           Prestamos.length!==0?
              Prestamos.map((elemento, i) => (
                <Row row={elemento} key={i} />
              ))
              :
            <div className="loaderContent">
         <Loader
          type="ThreeDots"
          color="#0075bb"
          height={100}
          width={100}
        />
      </div>
           :
           <div className="ErrorMessage">
             <span>{Error}</span>
           </div>
           }
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
const Row = ({ row }) => {
  const [checked, setchecked] = useState(false);
  useEffect(() => {
 
  }, [checked])
  return (
    <StyledTableRow key={row.name} className="rowTableBody">
      <StyledTableCell align="center" component="th" scope="row">
      <input
   type="radio"
   onClick={(e) => {
     setchecked(!checked)  
    }}
   checked={checked}
/>
      </StyledTableCell>
      <StyledTableCell align="left">{row.producto}</StyledTableCell>
      <StyledTableCell align="center">{row.codproducto}</StyledTableCell>
      <StyledTableCell align="center">{row.caja}</StyledTableCell>
      <StyledTableCell align="center">{row.unidad}</StyledTableCell>
      <StyledTableCell align="center">{row.tipoprestamo}</StyledTableCell>
      <StyledTableCell align="center">{row.valor}</StyledTableCell>
{/*       <StyledTableCell align="center">{row.Compania}</StyledTableCell> */}
    </StyledTableRow>
  );
};

const Pendientes = () => {
  return (
    <div className="twoContent">
      <div className="twoHeader">
        <h1>Estas son tus solicitudes pendientes</h1>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et
        </p>
      </div>
    </div>
  );
};

export default MisPrestamos;
